/**
 * Az excelben a dátumot reprezentáló számot alakítja vissza dátummá.
 * @param {number} excelNumber - Az exceltől kapott érték.
 * @returns {Date} Dátum.
 */
module.exports.getDateFromExcelNumber = function getDateFromExcelNumber (excelNumber) {
  const utcDays = Math.floor(excelNumber - 25569) // Az 1900.01.01-től eltelt napok
  const utcMilliseconds = utcDays * 86400 * 1000 // 1 nap = 86400 másodperc = 86400 000 millisecond
  const date = new Date(utcMilliseconds)

  // Az Excel belsően szökőév miatt tartalmaz egy "extra" napot (1900.02.29),
  // ezért a korábbi dátumoknál hozzá kell adni egy napot.
  if (excelNumber < 60) {
    date.setDate(date.getDate() + 1)
  }

  return date
}
